import { useTheme } from '@mui/material';

/**
 * Shared control-room palette derived from the active MUI theme, so every
 * control tower / immersive screen follows light/dark (and the ThemeSwitcher)
 * instead of hardcoding dark navy. Keeps the operational character (status
 * colors, dense panels) while respecting the theme.
 */
export interface ControlRoomColors {
  bg: string; panel: string; panel2: string; line: string; text: string; sub: string;
  good: string; warn: string; bad: string; accent: string; purple: string; cyan: string;
}

export const makeControlRoomColors = (theme: any): ControlRoomColors => ({
  bg: theme.palette.background.default,
  panel: theme.palette.background.paper,
  panel2: theme.palette.mode === 'dark' ? theme.palette.background.default : theme.palette.grey[100],
  line: theme.palette.divider,
  text: theme.palette.text.primary,
  sub: theme.palette.text.secondary,
  good: theme.palette.success.main,
  warn: theme.palette.warning.main,
  bad: theme.palette.error.main,
  accent: theme.palette.primary.main,
  purple: theme.palette.secondary.main,
  cyan: theme.palette.info.main,
});

export const useControlRoomColors = (): ControlRoomColors => makeControlRoomColors(useTheme());
